import React, { Children } from 'react';

import './GenericAccordion.scss';

function GenericAccordion(props) {

    const { children, id, onExpand } = props;

    const childs = [];
    Children.forEach(children, (ch, idx) => {
        childs.push(ch);
    });
    return (
        <div className="contentWrapper">
            <div className="contentRight">
                <div id="aspect-content">
                    <div className="aspect-tab ">
                        <input id={`generic.accordion-item-${id}`} type="checkbox" className="aspect-input" name="aspect" onChange={onExpand} />
                        <label htmlFor={`generic.accordion-item-${id}`} className="aspect-label"></label>
                        {
                            childs[0]
                        }
                        <div className="aspect-tab-content">
                            <div className="sentiment-wrapper">
                                {
                                    childs[1]
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    );
}

export default GenericAccordion;